import { gql } from "@apollo/client";

export const SET_SSO_PROVIDER = gql`
  mutation SetSSOProvider($input: SetSSOProviderInput!) {
    setSSOProvider(input: $input)
  }
`;
